<template>
  <div class="commission_income">
    <div v-if="member_commission.length > 0">
      <div
        class="commission_income_list flex"
        v-for="(item,index) in member_commission"
        :key="index"
      >
        <div class>{{item.source_member.nickname}}</div>
        <div class>
          <p class="c_i_price">+{{item.commission_price}}</p>
          <p class="c_i_time">{{item.create_time}}</p>
        </div>
      </div>
    </div>

    <div v-else style="text-align:center;font-size:.75rem;color:#999;margin-top:1rem;">暂无记录</div>

  </div>
</template>

<script>
export default {
  name: "commission_income",
  components: {},
  data() {
    return {
      member_commission: []
    };
  },
  created() {
    this.get_commission();
  },
  methods: {
    get_commission() {
      this.axios({
        url: this.api.member.get_commission,
        data: {}
      }).then(res => {
        if (res.error === 0) {
          this.member_commission = res.member_commission;
        }
      });
    }
  }
};
</script>
<style scoped>
.commission_income_list {
  background-color: white;
  padding: 0.5rem 0.75rem;
  font-size: 0.8rem;
  color: #484747;
  border-bottom: 1px solid #eee;
}
.c_i_price {
  color: #45b9bc;
  text-align: right;
}
.c_i_time {
  color: #838181;
  font-size: 0.6rem;
}
</style>



// WEBPACK FOOTER //
// src/views/center/recommend/commission_income.vue